import React from 'react';
import { PRODUCT_TO_NAME } from 'lib/enums/Product';
import { capitalize } from 'lodash';
import { Multiselect } from './Multiselect';

type ReportsProductFilterProps = {
  value: string[];
  onChange: (value: string[]) => void;
};

export function ReportsProductFilter({
  value,
  onChange
}: ReportsProductFilterProps) {
  const productOptions = Object.entries(PRODUCT_TO_NAME).map(
    ([key, product]) => {
      const productName = product.plural || key;
      return {
        value: productName,
        label: capitalize(productName)
      };
    }
  );

  return (
    <Multiselect
      value={value}
      onChange={onChange}
      options={productOptions}
      placeholder="Select Products"
      labelText="Filter by Products"
    />
  );
}
